export const baseURL = "http://localhost:3030"; // Replace with your actual API endpoint
export const localStorageKeyAPIToken = "tailor-my-resume-key";
